export default __webpack_public_path__ + "static/media/193.83be8d23.jpg";